export default __webpack_public_path__ + "static/media/Mass_08.8b712bc7.png";